module.exports = __webpack_public_path__ + "static/media/fail-loading.7ca9f11f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/fail-loading.svg
// module id = 906
// module chunks = 0